import { inject, Pipe, PipeTransform } from '@angular/core';
import { LOCALE_ID } from '@angular/core';

@Pipe({ name: 'ordinal' })
export class OrdinalPipe implements PipeTransform {
  private localeId = inject(LOCALE_ID);

  transform(value: number): string {
    if (this.localeId === 'pl') {
      return value + '.';
    } else {
      if (Math.floor(value / 10) % 10 === 1) {
        return value + 'th';
      }
      
      switch (value % 10) {
        case 1: return value + 'st';
        case 2: return value + 'nd';
        case 3: return value + 'rd';
        default: return value + 'th';
      }
    }
  }
}